import { render, staticRenderFns } from "./pxcard.vue?vue&type=template&id=6260597a"
import script from "./pxcard.vue?vue&type=script&lang=js"
export * from "./pxcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports